module.exports = __webpack_public_path__ + "static/media/PM86.f7a5912a.png";